import { useLayoutContext } from 'contexts/LayoutContext';
import FormWrapper from './FormWrapper';
import FeeSettingsForm from './FeeSettingsForm';
import useVehicle from 'hooks/lp/data/vehicle/useVehicle';
import PageContainer from 'components/PageContainer';

const FeeSettings: React.FC = () => {
  const { selectedVehicleId } = useLayoutContext();
  const { isLoading: vehicleLoading } = useVehicle(selectedVehicleId);
  return (
    <PageContainer loading={vehicleLoading}>
      <FormWrapper vehicleId={selectedVehicleId ?? ''}>
        <FeeSettingsForm />
      </FormWrapper>
    </PageContainer>
  );
};

export default FeeSettings;
